"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.StyledNotificationStickerContent=exports.StyledNotificationStickerClose=exports.StyledNotificationSticker=void 0;var _styledComponents=_interopRequireDefault(require("styled-components"));var _style=require("../../Icon/_style");var _constants=require("./_constants");var _utils=require("../_utils");function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e};}const StyledNotificationSticker=exports.StyledNotificationSticker=_styledComponents.default.div`
  position: relative;
  box-sizing: border-box;
  display: block;
  box-shadow: ${_constants.STYLES.STICKER_BOX_SHADOW};
  border-radius: 8px;
  border-left: ${props=>props.withLeftBorder?`8px solid ${(0,_utils.getBorderColor)(props.sType)}`:'none'};
  background: ${_constants.STYLES.BACKGROUND_COLOR};
  padding: ${props=>props.withLeftBorder?'12px 16px 12px 8px':'12px 16px 12px 16px'};
`;const StyledNotificationStickerContent=exports.StyledNotificationStickerContent=_styledComponents.default.div`
  position: relative;
  box-sizing: border-box;
  padding-right: ${props=>!props.isFullStickerContent&&props.isClosable?16:0}px;
`;const StyledNotificationStickerClose=exports.StyledNotificationStickerClose=_styledComponents.default.div`
  position: absolute;
  box-sizing: border-box;
  right: 0;
  top: 0;
  cursor: pointer;
  padding: 12px 16px;

  ${_style.StyledIconSvg} {
    fill: ${_constants.STYLES.STICKER_CLOSE_ICON_COLOR};
    transition: fill 0.32s ease-out;
  }

  :hover {
    ${_style.StyledIconSvg} {
      fill: ${_constants.STYLES.STICKER_CLOSE_ICON_COLOR_HOVER};
    }
  }
`;